export var getTableTranslation = function () {
    return ac_table_i18n;
};
export var getTableConfig = function () {
    return ac_table;
};
